var localization_select_default = (() => {
    if (!customElements.get("localization-select")) customElements.define("localization-select", class LocalizationSelect extends HTMLElement {
        form=null;
        select=null;
        label=null;
        connectedCallback() {
            this.form = this.querySelector("form");
            this.select = this.querySelector('select[name="country_code"]');
            this.label = this.querySelector("[data-label]");
            if (!this.form || !this.select) return;
            this.syncLabel();
            this.select.addEventListener("change", this.onChange);
        }
        disconnectedCallback() {
            this.select?.removeEventListener("change", this.onChange);
        }
        onChange=() => {
            this.syncLabel();
            this.form.submit();
        };
        syncLabel() {
            if (!this.label || !this.select) return;
            const selected = this.select.options[this.select.selectedIndex];
            if (!selected) return;
            this.label.textContent = selected.dataset.label || selected.textContent;
        }
    });
})();